export const MAP_CONSTANTS = {
  mapCenter: [0, 0],
  zoomLevel: 3,
  // MarkerCluster skips isolated root markers when the minimum is fractional.
  minZoom: 2,
  worldBounds: [
    [-75, -300.0],
    [85, 300],
  ],
  australiaCenter: [-25.2744, 133.7751],
  australiaZoom: 5,
};

// Helper function to create marker SVG strings
export const createMarkerSVG = (color) => {
  return `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path fill="${color}" d="M12 0c-4.198 0-8 3.403-8 7.602 0 4.198 3.469 9.21 8 16.398 4.531-7.188 8-12.2 8-16.398 0-4.199-3.801-7.602-8-7.602zm0 11c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z"/>
  </svg>`;
};

export const createLockSVG = (color) => {
  return `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fillRule="evenodd" clipRule="evenodd">
    <path fill="${color}" d="M18 10v-4c0-3.313-2.687-6-6-6s-6 2.687-6 6v4h-3v14h18v-14h-3zm-5 7.723v2.277h-2v-2.277c-.595-.347-1-.984-1-1.723 0-1.104.896-2 2-2s2 .896 2 2c0 .738-.404 1.376-1 1.723zm-5-7.723v-4c0-2.206 1.794-4 4-4 2.205 0 4 1.794 4 4v4h-8z"/>
  </svg>`;
};
